"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueAllSelectedCells = void 0;
const constants_1 = require("../../../helpers/constants");
const getValueAllSelectedCells = () => (Object.assign({}, constants_1.DAYS.map(() => constants_1.DISPLAY_EU_HOURS.slice(0, -1))));
exports.getValueAllSelectedCells = getValueAllSelectedCells;
//# sourceMappingURL=getValueAllSelectedCells.js.map